import React, { MouseEvent, useEffect, useState } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Hyperlink, VRM } from '@motorway/mw-highway-code/alpha';
import { BUTTON_AS_TYPE, TYPOGRAPHY, VARIANT } from '@motorway/mw-highway-code/enums';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities/index';
import { VehicleLookupState } from 'Utilities/vehicles/@types';

import LocalTexts from '../../../homepage/HomepageTexts.json';

import styles from './HeroVehicle.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string, args?: Record<string, string>) => `${LocalT.translate(key, args)}`;

type HeroVehicleProps = {
  className?: string;
  isCompactDesign?: boolean;
  onNotMyCarClickHandler: (value: string) => void,
  vehicle: VehicleLookupState;
};

export const HeroVehicle = ({
  className,
  onNotMyCarClickHandler,
  vehicle,
}: HeroVehicleProps) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  if (!vehicle) {
    return null;
  }

  const manufactureYear = vehicle.manufactureYear?.toString() ?? vehicle.year?.toString();
  const { body, colour, fuel } = vehicle ?? {};

  const vehicleMakeAndModel = `${vehicle.make?.display_name} ${vehicle.model}`;

  return (
    <div className={cx(styles.component, className)}>
      <div className={cx(styles.vrmBadgeContainer, {
        [styles.show]: loaded,
      })}>
        <VRM
          data-thc-badge-small
          id={vehicle.vrm_pretty}
          side= {'front'}
          size={TYPOGRAPHY.SMALL}
          text={vehicle.vrm_pretty as string}
        />
        <VRM
          data-thc-badge-regular
          id={vehicle.vrm_pretty}
          side= {'front'}
          size={TYPOGRAPHY.REGULAR}
          text={vehicle.vrm_pretty as string}
        />
      </div>

      <h1
        className={styles.title}
        {...applyCypressData(cypressIds.strings.vehicleMakeAndModel)}
      >
        {vehicleMakeAndModel}
      </h1>
      <ul
        className={styles.details}
        {...applyCypressData(cypressIds.strings.vehicleSpecifics)}>
        { manufactureYear && <li>{ manufactureYear }</li>}
        { colour && <li>{ colour }</li>}
        { body && <li>{ body }</li>}
        {fuel && <li>{fuel}</li>}
        <li>
          <Hyperlink
            data-thc-hyperlink
            as={ BUTTON_AS_TYPE.ANCHOR }
            data-cy={ 'notMyCar' }
            data-testid={'notYourCar'}
            href={ '/' }
            label={ t('hero.mileageStep.notYourCar') }
            onClick={ (e: MouseEvent) => {
              e.preventDefault();
              onNotMyCarClickHandler(vehicle.vrm ?? '');
            } }
            variant={ VARIANT.SECONDARY }
          />
        </li>
      </ul>
    </div>
  );
};
